import { sanitizeHtml } from 'wa-storybook/helpers/sanitize';
import classNames from 'classnames';

import styles from './help-center-comp.module.scss';

type Props = {
  helpText: string;
  className?: string;
};

const HelpCenterComp = ({ helpText, className }: Props) => (
  <div
    className={classNames(styles.container, className)}
    dangerouslySetInnerHTML={{ __html: sanitizeHtml(helpText) }}
  />
);
HelpCenterComp.displayName = 'HelpCenterComp';
export default HelpCenterComp;
